// extracted by mini-css-extract-plugin
export default {"About":"About_About__77cHe","About__Text":"About_About__Text__z6UCE","About__Title":"About_About__Title__L6qtT"};